import type { FC, ReactNode } from 'react'
import type { BoxProps } from '@chakra-ui/react'
import { Box, Flex, VStack } from '@chakra-ui/react'
import { BiCart } from 'react-icons/bi'
import { GrandNextLink, GrandPopover, GrandText } from '../../../common'

export interface ICartButtonProps extends BoxProps {
  badgeCount: number
  isOpen: boolean
  isHidden: boolean
  children: ReactNode | ReactNode[]
  path: string
}

export const CartButton: FC<ICartButtonProps> = ({
  path,
  children,
  isOpen,
  badgeCount,
  isHidden,
  ...props
}) => {
  if (isHidden) {
    return null
  }

  return (
    <GrandPopover
      id="cart-popover"
      {...{ isOpen }}
      contentProps={{
        width: '100%',
        maxWidth: '24rem',
        _focus: {
          outlineColor: 'transparent'
        },
        _focusVisible: {
          outlineColor: 'transparent'
        }
      }}
      target={
        <Box {...props}>
          <Box position="relative">
            {badgeCount > 0 && (
              <Flex
                align="center"
                bg="status.warning"
                borderRadius="full"
                cursor="default"
                fontSize="xs"
                h={5}
                justify="center"
                minW={5}
                position="absolute"
                px={1}
                right="-60%"
                top="-60%"
                zIndex={101}
              >
                <GrandText textAlign="center">{badgeCount}</GrandText>
              </Flex>
            )}

            <GrandNextLink
              alignItems="center"
              aria-label="add to cart"
              color="var(--chakra-colors-component-TopNavContent-CartButton-color, var(--chakra-colors-text-default))"
              href={path}
              justifyContent="center"
              shadow="none"
              size="sm"
            >
              <BiCart size={22} />
            </GrandNextLink>
          </Box>
        </Box>
      }
      title=""
    >
      <VStack px={2}>{children}</VStack>
    </GrandPopover>
  )
}
